import React from "react";
import Loadable from "react-loadable";
import Loading from "./views/Component/Loading";
//import RemoteTerminal from './views/CRUD/RemoteTerminal/RemoteTerminal';

function Load() {
  return <Loading loading />;
}

const MfaSettings = Loadable({
  loader: () => import("./views/Pages/MfaSettings/MfaSettings"),
  loading: Load,
});

const GroupOfBoxes = Loadable({
  loader: () => import("./views/CRUD/GroupOfBoxes/GroupOfBoxes"),
  loading: Load,
})

const StUsers = Loadable({
  loader: () => import("./views/CRUD/GroupOfBoxes/StUsers"),
  loading: Load,
})

const ChangePassword = Loadable({
  loader: () => import("./views/Pages/ChangePassword/ChangePassword"),
  loading: Load,
});

const Page404 = Loadable({
  loader: () => import("./views/Pages/Page404/Page404"),
  loading: Load,
});

const SectionInProgress = Loadable({
  loader: () => import("./views/Pages/SectionInProgress/SectionInProgress"),
  loading: Load,
});

const CommerceType = Loadable({
  loader: () => import("./views/CRUD/CommerceType/CommerceType"),
  loading: Load,
});

const CommerceTypeEdit = Loadable({
  loader: () => import("./views/CRUD/CommerceTypeEdit/CommerceTypeEdit"),
  loading: Load,
});

const Country = Loadable({
  loader: () => import("./views/CRUD/Country/Country"),
  loading: Load,
});

const Currency = Loadable({
  loader: () => import("./views/CRUD/Currency/Currency"),
  loading: Load,
});

const CountryEdit = Loadable({
  loader: () => import("./views/CRUD/CountryEdit/CountryEdit"),
  loading: Load,
});

const Dashboard = Loadable({
  loader: () => import("./views/Dashboard/Dashboard"),
  loading: Load,
});

const DocumentType = Loadable({
  loader: () => import("./views/CRUD/DocumentType/DocumentType"),
  loading: Load,
});

const DocumentTypeEdit = Loadable({
  loader: () => import("./views/CRUD/DocumentTypeEdit/DocumentTypeEdit"),
  loading: Load,
});

const DeleteEquipment = Loadable({
  loader: () => import("./views/CRUD/DeleteEquipment/DeleteEquipment"),
  loading: Load,
});

const Entity = Loadable({
  loader: () => import("./views/CRUD/Entity/Entity"),
  loading: Load,
});
const EntityEdit = Loadable({
  loader: () => import("./views/CRUD/EntityEdit/EntityEdit"),
  loading: Load,
});

const EntityType = Loadable({
  loader: () => import("./views/CRUD/EntityType/EntityType"),
  loading: Load,
});

const EntityTypeEdit = Loadable({
  loader: () => import("./views/CRUD/EntityTypeEdit/EntityTypeEdit"),
  loading: Load,
});

const Locality = Loadable({
  loader: () => import("./views/CRUD/Locality/Locality"),
  loading: Load,
});

const LocalityEdit = Loadable({
  loader: () => import("./views/CRUD/LocalityEdit/LocalityEdit"),
  loading: Load,
});

const PointOfSale = Loadable({
  loader: () => import("./views/CRUD/PointOfSale/PointOfSale"),
  loading: Load,
});

const PointOfSaleEdit = Loadable({
  loader: () => import("./views/CRUD/PointOfSaleEdit/PointOfSaleEdit"),
  loading: Load,
});

const Profile = Loadable({
  loader: () => import("./views/CRUD/Profile/Profile"),
  loading: Load,
});

const ProfileEdit = Loadable({
  loader: () => import("./views/CRUD/ProfileEdit/ProfileEdit"),
  loading: Load,
});

const Province = Loadable({
  loader: () => import("./views/CRUD/Province/Province"),
  loading: Load,
});

const ProvinceEdit = Loadable({
  loader: () => import("./views/CRUD/ProvinceEdit/ProvinceEdit"),
  loading: Load,
});

const RemoteTerminal = Loadable({
  loader: () => import("./views/CRUD/RemoteTerminal/RemoteTerminal"),
  loading: Load,
});

const RemoteTerminalEdit = Loadable({
  loader: () => import("./views/CRUD/RemoteTerminalEdit/RemoteTerminalEdit"),
  loading: Load,
});

const TaskAssignment = Loadable({
  loader: () => import("./views/Configuration/TaskAssignment"),
  loading: Load,
});

const TaskList = Loadable({
  loader: () => import("./views/CRUD/TaskList/TaskList"),
  loading: Load,
});

const User = Loadable({
  loader: () => import("./views/CRUD/User/User"),
  loading: Load,
});

const UserEdit = Loadable({
  loader: () => import("./views/CRUD/UserEdit/UserEdit"),
  loading: Load,
});

const TelesupervisorProfile = Loadable({
  loader: () =>
    import("./views/CRUD/TelesupervisorProfile/TelesupervisorProfile"),
  loading: Load,
});

const TelesupervisorProfileEdit = Loadable({
  loader: () =>
    import("./views/CRUD/TelesupervisorProfileEdit/TelesupervisorProfileEdit"),
  loading: Load,
});

const ScriptAssigment = Loadable({
  loader: () => import("./views/Configuration/Release/ScriptAssigment"),
  loading: Load,
});

const StRelease = Loadable({
  loader: () => import("./views/CRUD/StRelease/StRelease"),
  loading: Load,
});

const Observation = Loadable({
  loader: () => import("./views/CRUD/Observation/Observation"),
  loading: Load,
});

const ObservationEdit = Loadable({
  loader: () => import("./views/CRUD/ObservationEdit/ObservationEdit"),
  loading: Load,
});

const StConf = Loadable({
  loader: () => import("./views/Configuration/StConf/StConf"),
  loading: Load,
});

const routes = [
  {
    path: "/dashboard",
    id: null,
    name: "dashboard",
    component: Dashboard,
    exact: true,
  },
  {
    path: "/mfa-settings",
    id: null,
    name: "mfa-settings",
    component: MfaSettings,
    exact: true,
  },
  {
    path: "/group-of-boxes",
    id: 369,
    name: "group-of-boxes",
    component: GroupOfBoxes,
    exact: true
  },
  {
    path: "/users",
    id: 370,
    name: "users",
    component: StUsers,
    exact: true
  },
  {
    path: "/country",
    id: 345,
    name: "country",
    component: Country,
    exact: true,
  },
  {
    path: "/country-edit",
    id: 345,
    name: "country-edit",
    component: CountryEdit,
    exact: true,
  },
  {
    path: "/province",
    id: 346,
    name: "province",
    component: Province,
    exact: true,
  },
  {
    path: "/province-edit",
    id: 346,
    name: "province-edit",
    component: ProvinceEdit,
    exact: true,
  },
  {
    path: "/locality",
    id: 347,
    name: "locality",
    component: Locality,
    exact: true,
  },
  {
    path: "/locality-edit",
    id: 347,
    name: "locality-edit",
    component: LocalityEdit,
    exact: true,
  },
  {
    path: "/delete-equipment",
    id: 358,
    name: "delete-equipment",
    component: DeleteEquipment,
    exact: true,
  },
  { 
    path: "/user", 
    id: 356, 
    name: "user", 
    component: User, 
    exact: true 
  },
  {
    path: "/user-edit",
    id: 356,
    name: "user-edit",
    component: UserEdit,
    exact: true,
  },
  {
    path: "/change-password",
    id: null,
    name: "change-password",
    component: ChangePassword,
    exact: true,
  },
  {
    path: "/section-in-progess",
    id: null,
    name: "section-in-progess",
    component: SectionInProgress,
    exact: true,
  },
  {
    path: "/task-assignment",
    id: 348,
    name: "task-assignment",
    component: TaskAssignment,
    exact: true,
  },
  { 
    path: "/entity", 
    id: 350, 
    name: "entity", 
    component: Entity, 
    exact: true 
  },
  {
    path: "/entity-edit",
    id: 350,
    name: "entity-edit",
    component: EntityEdit,
    exact: true,
  },
  {
    path: "/point-of-sale",
    id: 360,
    name: "point-of-sale",
    component: PointOfSale,
    exact: true,
  },
  {
    path: "/point-of-sale-edit",
    id: 360,
    name: "point-of-sale-edit",
    component: PointOfSaleEdit,
    exact: true,
  },
  {
    path: "/task-list",
    id: 349,
    name: "task-list",
    component: TaskList,
    exact: true,
  },
  {
    path: "/remote-terminal",
    id: 352,
    name: "remote-terminal",
    component: RemoteTerminal,
    exact: true,
  },
  {
    path: "/remote-terminal-edit",
    id: 352,
    name: "remote-terminal-edit",
    component: RemoteTerminalEdit,
    exact: true,
  },
  {
    path: "/remote-terminal-config",
    id: 352,
    name: "remote-terminal-config",
    component: StConf,
    exact: true,
  },
  {
    path: "/document-type",
    id: 344,
    name: "document-type",
    component: DocumentType,
    exact: true,
  },
  {
    path: "/document-type-edit",
    id: 344,
    name: "document-type-edit",
    component: DocumentTypeEdit,
    exact: true,
  },
  {
    path: "/entity-type",
    id: 351,
    name: "entity-type",
    component: EntityType,
    exact: true,
  },
  {
    path: "/entity-type-edit",
    id: 351,
    name: "entity-type-edit",
    component: EntityTypeEdit,
    exact: true,
  },
  {
    path: "/commerce-type",
    id: 343,
    name: "commerce-type",
    component: CommerceType,
    exact: true,
  },
  {
    path: "/commerce-type-edit",
    id: 343,
    name: "commerce-type-edit",
    component: CommerceTypeEdit,
    exact: true,
  },
  {
    path: "/profile",
    id: 357,
    name: "profile",
    component: Profile,
    exact: true,
  },
  {
    path: "/profile-edit",
    id: 357,
    name: "profile-edit",
    component: ProfileEdit,
    exact: true,
  },
  {
    path: "/telesupervisor-profile",
    id: 353,
    name: "telesupervisor-profile",
    component: TelesupervisorProfile,
    exact: true,
  },
  {
    path: "/telesupervisor-profile-edit",
    id: 353,
    name: "telesupervisor-profile-edit",
    component: TelesupervisorProfileEdit,
    exact: true,
  },
  {
    path: "/st-script",
    id: 354,
    name: "st-script",
    component: StRelease,
    exact: true,
  },
  {
    path: "/script-assignment",
    id: 355,
    name: "script-assignment",
    component: ScriptAssigment,
    exact: true,
  },
  {
    path: "/currency",
    id: 361,
    name: "currency",
    component: Currency,
    exact: true,
  },
  {
    path: "/observation",
    id: 364,
    name: "observation",
    component: Observation,
    exact: true,
  },
  {
    path: "/observation-edit",
    id: 364,
    name: "observation-edit",
    component: ObservationEdit,
    exact: true,
  },
  {
    path: "/page404",
    id: null,
    name: "page404",
    component: Page404,
    exact: false,
  },
];

export default routes;
